// filepath: /Users/sird/Downloads/QrButler-330eb0312a86783b6eba24778b016ec58ad434ea/src/services/supabase.js
import { createClient } from '@supabase/supabase-js'

// For React apps using Create React App:
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);